import React, { useEffect, useState, createContext } from "react";
import "./App.scss";
import Page1 from "./pages/Page1";
import Page2 from "./pages/Page2";

export const SiteContext = createContext();
function App() {
  const [currentPage, setCurrentPage] = useState(1);

  const dataValue = {
    currentPage,
    setCurrentPage,
  };
  return (
    <SiteContext.Provider value={dataValue}>
      <div className="App">
        <div className="container">
          {currentPage === 1 && <Page1 />}
          {currentPage === 2 && <Page2 />}
        </div>
      </div>
    </SiteContext.Provider>
  );
}

export default App;
